document.addEventListener("DOMContentLoaded", () => {
  const upsellContainers = document.querySelectorAll(".product-upsell");

  upsellContainers.forEach(container => {
    const checkboxes = container.querySelectorAll('[js-upsell-product-field]');
    const extraPriceElement = container.querySelector('[js-upsell-extra-price]');
    let currencySymbol = '';
    
    if (checkboxes.length) {
      currencySymbol = checkboxes[0].dataset.currency || '£';
    }

    const updateExtraPrice = () => {
      let total = 0;

      checkboxes.forEach(checkbox => {
        if (checkbox.checked) {
          const price = parseFloat(checkbox.dataset.productPrice || 0);
          if (price > 0) total += price;
        }
      });

      extraPriceElement.textContent = `+${currencySymbol}${total.toFixed(2)}`;
    };

    const updatePrintValue = (value) => {
      document.querySelector(`[js-print-option-item][data-value="${value}"]`)?.click();
    }

    checkboxes.forEach(checkbox => {
      checkbox.addEventListener("change", function() {
        // updatePrintValue(this.value);
        updateExtraPrice();
      });
    });
  });
});